import { useMutation, useQuery, useQueryClient } from 'react-query'
import {
  ExamesImagemAtendimento,
  SolicitacaoExameImagem,
} from '../../../../atendimento/core/_models'
import {
  cancelarSolicitacaoExameImagem,
  getDispositivosExameImagem,
  getExamesImagemAtendimento,
  solicitarExameImagem,
} from '../../../../atendimento/core/_requests'

export const chaveExamesImagem = (idAtendimento: number) => ['exames-imagem', idAtendimento]

const chaveDispositivos = (idAtendimento: number) => ['exames-imagem-dispositivos', idAtendimento]

export const useExamesImagemAtendimento = (idAtendimento: number) =>
  useQuery(chaveExamesImagem(idAtendimento), () => getExamesImagemAtendimento(idAtendimento), {
    enabled: !!idAtendimento,
    refetchOnWindowFocus: false,
  })

/** Só carrega quando o formulário abre; sem retry para o 403 aparecer na hora. */
export const useDispositivosExameImagem = (idAtendimento: number, habilitado: boolean) =>
  useQuery(chaveDispositivos(idAtendimento), () => getDispositivosExameImagem(idAtendimento), {
    enabled: habilitado && !!idAtendimento,
    retry: false,
    refetchOnWindowFocus: false,
  })

export const useSolicitarExameImagem = (idAtendimento: number) => {
  const queryClient = useQueryClient()
  return useMutation(
    (idTelekitDispositivo: number) => solicitarExameImagem(idAtendimento, idTelekitDispositivo),
    {
      onSuccess: () => queryClient.invalidateQueries(chaveExamesImagem(idAtendimento)),
    }
  )
}

const substituirSolicitacao = (
  atual: ExamesImagemAtendimento | undefined,
  cancelada: SolicitacaoExameImagem
): ExamesImagemAtendimento | undefined =>
  atual && {
    ...atual,
    solicitacoes: {
      ...atual.solicitacoes,
      data: (atual.solicitacoes.data ?? []).map((s) => (s.id === cancelada.id ? cancelada : s)),
    },
  }

export const useCancelarExameImagem = (idAtendimento: number) => {
  const queryClient = useQueryClient()
  return useMutation(
    (idSolicitacao: number) => cancelarSolicitacaoExameImagem(idAtendimento, idSolicitacao),
    {
      onSuccess: (cancelada) => {
        queryClient.setQueryData<ExamesImagemAtendimento | undefined>(
          chaveExamesImagem(idAtendimento),
          (atual) => substituirSolicitacao(atual, cancelada)
        )
        queryClient.invalidateQueries(chaveExamesImagem(idAtendimento))
      },
    }
  )
}
